const useGetPhoneNumber = (langPrefix: string) => {
  const numbers: Record<string, Record<string, string>> = {
    default: {
      text: '+1 (877) 210-9890',
      link: 'tel:+18772109890'
    },
    en: {
      text: '(888) 875-1867',
      link: 'tel:+18888751867'
    },
    de: {
      text: '+31 (0) 20-225-1568',
      link: 'tel:+310202251568'
    },
    fr: {
      text: '+31 (0) 20-225-1568',
      link: 'tel:+310202251568'
    },
    nl: {
      text: '+31 (0) 20-225-1568',
      link: 'tel:+310202251568'
    },
    ja: {
      text: '',
      link: ''
    }
  };

  if (
    numbers[langPrefix] &&
    numbers[langPrefix].link &&
    numbers[langPrefix].text
  ) {
    return numbers[langPrefix];
  }
  return null;
};

export default useGetPhoneNumber;
